

const ValuerAmendSubtitle = (props) => {

    const value = props.value

    return (
        <div className="valuer-amend-accordion-subtitle" dangerouslySetInnerHTML={{__html: value && value}}/>
    )
}

export default ValuerAmendSubtitle;